var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctbsc-list"},_vm._l((_vm.goods),function(good){return _c('van-card',{attrs:{"price":good.point,"desc":good.description,"title":good.title,"thumb":good.cover,"currency":'积分：'},on:{"click":function($event){return _vm.detail(good.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }